module.exports = __webpack_public_path__ + "static/img/logo_pdf.e254a400.svg";